import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface Crumb {
  label: string;
  href?: string;
}

const nameMap: Record<string, string> = {
  category: '分类',
  about: '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  const crumbs: Crumb[] = [{ label: '首页', href: '/' }];

  if (segments[0] === 'category') {
    crumbs.push({ label: '赛事分类' });
    if (segments[1]) {
      const cat = categories.find((c) => c.slug === segments[1]);
      crumbs.push({ label: cat?.name || segments[1] });
    }
  } else if (segments[0] === 'article') {
    crumbs.push({ label: '资讯详情' });
  } else if (segments[0] === 'about') {
    crumbs.push({ label: '关于我们' });
  }

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 pt-20">
      <div className="max-w-7xl mx-auto py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {crumbs.map((crumb, i) => (
            <li key={i} className="flex items-center gap-1">
              {i > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-300 text-xs"></i>
              )}
              {crumb.href ? (
                <Link
                  to={crumb.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}